import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_DISCHARGE
} from "../types";

export const getDischarge = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/discharges`);
        dispatch({ type: GET_DISCHARGE, payload: data });
    } catch (error) {
    }
};

export const updateDischarge = (params) => async (dispatch, getState) => {
    try {
        await api.put(`/discharges/${params.iddischarge}`, params);
        await dispatch(getDischarge());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось обновить запись");
    }
}

export const createDischarge = (data) => async (dispatch, getState) => {
    try {
        await api.post(`/discharges`, data);
        await dispatch(getDischarge());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteDischarge = (groupsId) => async (dispatch, getState) => {
    try {
        await api.delete(`/discharges/${groupsId}`);
        await dispatch(getDischarge());
        createNotification('success', 'Успешно');
    } catch (error) {
        createNotification('error', "Не удалось удалить запись");
    }
};
